import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function LinkInterceptor() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target.closest("a"); // find <a> tag if clicked inside
      if (!target) return;

      const href = target.getAttribute("href");

      // Check for empty or #
      if (href === "#" || href === "") {
        e.preventDefault();
        navigate("/coming-soon"); // redirect to ComingSoon page
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [navigate]);

  return null; // no UI
}

export default LinkInterceptor;
